import { lazyComponent } from "common/lazy-loading";

export const LazyAIAssistantController = lazyComponent(() =>
  import("./controller").then((m) => ({ default: m.AssistantPanelController })),
);
